<i18n src="../../locales/lang.json"></i18n>

<template>
  <div>
    <modal-no-ref v-bind:title="$t('forgot_password')" ref="thisModal" v-bind:onsave="doSave" size="modal-xs mx-4 mx-md-auto">
      <form id="forgotPasswordForm" name="forgotPasswordForm" class="login-formx form-validate" action="index.html" onsubmit="return false">
        <div class="card m-0 shadow-0 border-0">
          <div class="card-body pt-2">
            <div class="text-center mb-2">
              <i class="icon-spinner11 icon-2x text-warning border-warning border-3 rounded-pill p-3 mb-2 mt-1"></i>
              <h5 class="mb-0">{{$t('password_recovery')}}</h5>
              <span class="d-block text-muted">{{$t('password_recovery_message')}}</span>
            </div>

            <div class="form-group form-group-feedback form-group-feedback-right">
              <input required v-model="email" type="email" class="form-control" placeholder="Your email">
              <div class="form-control-feedback">
                <i class="icon-mail5 text-muted"></i>
              </div>
            </div>

            <div class="form-group">
              <button type="submit" @click="forgotPassword" class="btn skin primary-button btn-block"><i class="icon-spinner11 mr-2"></i>{{$t('reset_password')}}</button>
            </div>

            <div class="text-center mt-1">
              <a href="#" @click="openLogin()">{{$t('login')}}</a>
            </div>
            <div class="text-center">
              <a href="#" @click="openRegister()">{{$t('register')}}</a>
            </div>
            <div class="col-12">
              <div v-if="msg != null && msg != ''" class="col-12 alert shadow-0 alert-success border-0 upload-error-message mt-3" role="alert">
                <ul>
                  <li class="col-12">
                    {{ msg }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </form>
    </modal-no-ref>
  </div>

</template>

<script>

  import ModalNoRef from "../modals/modal-no-ref.vue";
  var msg = "";
  export default {
    name: "forgot-password",
    components: {
      ModalNoRef
    },
    props: {
      user: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        email: "",
        msg,
      };
    },
    methods: {
      openRegister() {
        this.close();
        this.$emit('doregister');
        vm.$root.$emit('callToOpenRegister');
      },
      openLogin() {
        this.close();
        try {
          this.$parent.open();
          this.$emit('open');
        } catch (error) {
          this.$emit('open');
          vm.$root.$emit('registerCallToOpenLogin');
        }
      },

      async authenticate() {
        try {
          var data = {
            username: 'olle',
            password: 'bertil'
          };

          this.$http.post('/api/authenticate', data).then(async response => {
            var response = response.data;
          }).then((async response => {

          }
          ));
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async forgotPassword() {
        this.msg = '';
        if (!$('#forgotPasswordForm').valid())
          return false;
        try {
          var data = {
            email: this.email,
            culLang: this.$i18n.locale,
          };

          this.$http.post('/api/Membership/forgotpassword', data).then(async response => {
            var response = response.data;
            this.email = '';
            if (response) {
              this.msg = this.$t('forgotpassword_success');
            } else {
              this.msg = this.$t('forgotpassword_error');
            }
            this.$forceUpdate();
          }).then((async response => {

          }
          ));
        } catch (err) {
          alert('some error:' + err)
        }
      },
      open() {
        this.$refs.thisModal.open();
      },
      close() {
        this.$refs.thisModal.close();
      },

      handleRefresh(val) {
        this.$forceUpdate();
      }
    },
    computed: {

    },
    watch: {

    },
    mounted() {
      _componentValidation('#forgotPasswordForm');
    },
    created() {

    },
  };

</script>



// WEBPACK FOOTER //
// src/components/login/forgot-password.vue